import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useTryInStoreContext } from '../context/context.js';
import { useProducts } from './use-products.js';

const getProductBySku = (productList, sku)=>{
    return productList === null || productList === void 0 ? void 0 : productList.find((product)=>product.sku === sku
    );
};
const useTryInStore = ()=>{
    const [tryInStoreStorage, storageHandlers] = useTryInStoreContext();
    const [getProducts, { data , called , error  }] = useProducts();
    const products = React.useMemo(()=>{
        var ref;
        return (ref = tryInStoreStorage === null || tryInStoreStorage === void 0 ? void 0 : tryInStoreStorage.map((storageItem)=>{
            const product = getProductBySku(data, storageItem.sku);
            if (product) {
                return swcHelpers.objectSpread({}, product, {
                    __itemType: 'product'
                });
            }
            // If there is a product found, return something
            if (called && data && !product) {
                return swcHelpers.objectSpread({}, storageItem, {
                    __itemType: 'notFound'
                });
            }
            return swcHelpers.objectSpread({}, storageItem, {
                __itemType: 'storage'
            });
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        tryInStoreStorage,
        data,
        called
    ]);
    const fetchProducts = React.useCallback(()=>{
        const skus = tryInStoreStorage === null || tryInStoreStorage === void 0 ? void 0 : tryInStoreStorage.map(({ sku  })=>sku
        );
        if (skus) {
            getProducts(skus);
        }
    }, [
        getProducts,
        tryInStoreStorage
    ]);
    var _length;
    const state = React.useMemo(()=>({
            error,
            products: error ? null : products,
            itemCount: (_length = products.length) !== null && _length !== void 0 ? _length : 0
        })
    , [
        error,
        products
    ]);
    const handlers = React.useMemo(()=>({
            fetchProducts,
            storage: storageHandlers
        })
    , [
        fetchProducts,
        storageHandlers
    ]);
    return [
        state,
        handlers
    ];
};

export { useTryInStore };
//# sourceMappingURL=use-try-in-store.js.map
